import React from 'react';
import { Gamepad2, Skull } from 'lucide-react';
import { ScrollArea } from '../ui/scroll-area';
import { MODE_ICONS, MODE_COLORS, formatDate } from './constants';

const GamesTab = ({ recentScores }) => (
  <div className="glass-card rounded-xl overflow-hidden">
    <div className="p-4 border-b border-[#222] bg-[#14F19510]">
      <h2 className="font-game text-sm text-[#14F195]">GAME HISTORY ({recentScores.length})</h2>
    </div>
    <ScrollArea className="h-[450px]">
      {recentScores.map((s, i) => {
        const MIcon = MODE_ICONS[s.game_mode] || Gamepad2;
        const color = MODE_COLORS[s.game_mode] || '#A1A1AA';
        return (
          <div key={i} className="flex items-center justify-between p-3 border-b border-[#1a1a1a] hover:bg-[#111]">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded flex items-center justify-center" style={{ backgroundColor: `${color}20` }}>
                <MIcon className="w-4 h-4" style={{ color }} />
              </div>
              <div>
                <p className="font-game text-sm text-[#FFD700]">{s.score?.toLocaleString()}</p>
                <p className="text-[10px] text-[#666]">{s.game_mode || 'classic'}</p>
              </div>
            </div>
            <div className="text-right">
              <div className="flex items-center gap-3 text-xs">
                <span className="text-[#9945FF]">LVL {s.level}</span>
                <span className="text-[#FF3B30] flex items-center gap-1"><Skull className="w-3 h-3" />{s.kills}</span>
              </div>
              <p className="text-[10px] text-[#666]">{formatDate(s.created_at)}</p>
            </div>
          </div>
        );
      })}
      {recentScores.length === 0 && (
        <div className="p-8 text-center"><p className="text-[#666]">No games played</p></div>
      )}
    </ScrollArea>
  </div>
);

export default GamesTab;
